var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.2044L4.5 18.8925C4.5 19.4514 4.71071 19.9875 5.08579 20.3827C5.46086 20.778 5.96957 21 6.5 21H18.5C19.0304 21 19.5391 20.778 19.9142 20.3827C20.2893 19.9875 20.5 19.4514 20.5 18.8925V15.2044M12.5011 3V14.9425M12.5011 14.9425L17.0725 10.3793M12.5011 14.9425L7.92969 10.3793",
    stroke: "#4B81F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload02);
export default __webpack_public_path__ + "static/media/download-02.5f63a1b63b8ee150aa0fc8dc9f405125.svg";
export { ForwardRef as ReactComponent };